import React from "react";
import Social from "../Social";

const heroContent = {
  shapeImage: "hero-shape",
  heroImage: "logo_avvocato-nobg",
  name: "Studio Legale Avv. Maria Macrino",
  description: `Lo Studio Legale fornisce un’assistenza qualificata e personalizzata, rispondendo celermente alle esigenze prospettate, grazie ad una organizzazione dinamica e professionale. 
  L’Avv. Maria Macrino pone la massima attenzione nell’aspetto personale nella gestione del rapporto cliente-professionista, ossia nel comprendere i suoi clienti, le loro esigenze e le loro aspettative. 
  
  `,
};

const Hero = () => {
  return (
    //    HERO
    <div className="edina_tm_hero" id="home">
      <div className="content">
        <div className="img-shape" data-aos="fade-up" data-aos-duration="1200">
          <img
            src={`img/logo/${heroContent.shapeImage}`}
            srcSet={`img/logo/${heroContent.heroImage}.png`}
            alt="hero image"
          />
        </div>
        <div className="extra">
          <h1
            className="name"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="100"
            style={{color: '#521115'}}
          >
            {heroContent.name}
          </h1>
          <h7
            className="name"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="100"
            // style={{color: '#e0a46a'}}
          >
            Diritto e Impegno
          </h7>
          <br/>
          <br/>
          <p
            className="text"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="200"
            style={{textAlign:"left"}}
          >
            <b>Lo Studio Legale</b> fornisce un’assistenza qualificata e personalizzata, rispondendo celermente alle esigenze prospettate grazie ad una organizzazione dinamica e professionale.
            <br/>
            <b>L’Avv. Maria Macrino</b> pone la massima attenzione all’aspetto personale nella gestione del rapporto cliente-professionista.
            <br/>
            Questa attitudine garantisce chiarezza, riservatezza e immediatezza nelle prestazioni in un clima di fiducia personale e professionale, nonché di stretta collaborazione con il cliente per raggiungere gli obiettivi desiderati.
          </p>
          <p
            className="text"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="200"
            style={{textAlign:"left"}}
          >
            
          </p>

          <div
            className="social"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="300"
          >
            <Social />
          </div>
          {/*<div
            className="edina_tm_button"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="400"
          >
            <a href="img/cv.png" download className="color">
              Download CV
            </a>
          </div>*/}
        </div>
      </div>
    </div>
    // /HERO
  );
};

export default Hero;
